import React from "react";

import { mdiContentCopy } from "@mdi/js";
import Icon from "@mdi/react";

import useCopyToClipboard from "../../hooks/useCopyToClipboard";

import type { JSX } from "react";

function CopyToClipboardButton({ value }: { value: string }): JSX.Element {
  const copyToClipboard = useCopyToClipboard();

  return (
    <button
      className="text-muted-foreground hover:text-muted-foreground absolute inset-y-0 right-0 flex items-center pr-[0.46875rem] transition-colors"
      onClick={async (): Promise<void> => copyToClipboard({ value })}
      type="button"
    >
      <Icon path={mdiContentCopy} size={0.9375} />
    </button>
  );
}

export default CopyToClipboardButton;
